import { PermissionType } from '../../types/common';

import {
  SubjectDetails, SUBJECTS,
} from './constants';

export const getSubjectPermission = (subjectKey: string, categoryTag: string): string =>
  `${PermissionType.Base}_${categoryTag}_${subjectKey.toUpperCase()}`;

// Get array of subjects based on permissions
export default (permissions: string[], categoryTag: string) => {
  let allowedSubjects: SubjectDetails[];
  if (permissions.includes(PermissionType.Base) || permissions.includes(`${PermissionType.Base}_${categoryTag}`)) {
    // If master access is granted, allow all subjects
    allowedSubjects = Object.values(SUBJECTS);
  } else {
    // Otherwise, check which subjects have a granted category or topic underneath it
    allowedSubjects = Object.values(SUBJECTS).filter((subject) =>
      permissions
        .some((permission) => permission
          .startsWith(getSubjectPermission(subject.key, categoryTag))));
  }

  // Using Promise.all to check for permissions returns the subjects in inconsistent order,
  // so sort the subjects list by the original order
  const allSubjectKeys: string[] = Object.keys(SUBJECTS);
  return allowedSubjects.sort(
    (a, b) =>
      allSubjectKeys.indexOf(a.key) - allSubjectKeys.indexOf(b.key),
  );
};
